import { ComposePanel } from './ComposePanel';
import { FeedbackPanel } from './FeedbackPanel';
import { EmailLog } from './EmailLog';
import { EmailTemplatesPanel } from './EmailTemplatesPanel';
import type { Dispatch, SetStateAction } from 'react';
import type { FeedbackRow } from '../../lib/admin-queries';

// Comms: the outbound + inbound message loop. Compose (email members), Contact
// (the inbox of messages from the floating Contact pill), and Email log (Resend
// delivery status). The Contact inbox data lives in the shell so its unread
// count can badge the top nav.

function cls(on: boolean) {
  return on ? 'admin__subpanel' : 'admin__subpanel admin__panel--hidden';
}

export function CommsSection({
  tab,
  feedback,
  setFeedback,
  feedbackLoading,
  composeHandoff,
  composeNonce,
}: {
  tab: string;
  feedback: FeedbackRow[];
  setFeedback: Dispatch<SetStateAction<FeedbackRow[]>>;
  feedbackLoading: boolean;
  composeHandoff: { email: string; display_name: string | null }[];
  composeNonce: number;
}) {
  return (
    <>
      <div className={cls(tab === 'compose')}>
        <ComposePanel active={tab === 'compose'} handoff={composeHandoff} handoffNonce={composeNonce} />
      </div>
      <div className={cls(tab === 'inbox')}>
        <FeedbackPanel feedback={feedback} setFeedback={setFeedback} loading={feedbackLoading} />
      </div>
      <div className={cls(tab === 'log')}>
        <EmailLog active={tab === 'log'} />
      </div>
      <div className={cls(tab === 'templates')}>
        <EmailTemplatesPanel active={tab === 'templates'} />
      </div>
    </>
  );
}
